import { Box, Typography } from "@mui/material";
import SectionHeader from "../../../../components/section-header/SectionHeader";
import SectionHeaderActions from "../../../../components/section-header/SectionHeaderActions";
import SectionHeaderSearch from "../../../../components/section-header/SectionHeaderSearch";
import FinancingRoundsDataGrid from "./FinancingRoundsDataGrid";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useRef, useState } from "react";

export default function FinancingRounds() {
  const gridRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  return (
    <Box display="flex" flexDirection="column" gap={2} mt={3} px={1}>
      {/* --- MATCHING ATTRACTIVE TITLE SECTION --- */}
      <Box 
        sx={{
          p: 2,
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          bgcolor: '#F3F4F6', // Light professional grey
          borderLeft: '4px solid #004D71', // Bessemer dark blue accent
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}
      >
        <InfoOutlinedIcon sx={{ color: '#004D71', fontSize: 28 }} />
        <Box>
          {/* <Typography sx={{ fontWeight: 700, color: '#111827', fontSize: '1rem' }}>
            Participation History
          </Typography> */}
          <Typography sx={{ color: '#4B5563', fontSize: '0.85rem' }}>
            Financing rounds that BVP has participated in.
          </Typography>
        </Box>
      </Box>

      {/* --- ACTIONS HEADER --- */}
      <SectionHeader
        left={
          <SectionHeaderSearch
            searchValue={searchText}
            onSearchChange={setSearchText}
            onFilterClick={() => gridRef.current?.openFiltersPanel()}
            onColumnClick={() => gridRef.current?.openColumnsPanel()}
          />
        }
        right={<SectionHeaderActions onExport={() => gridRef.current?.exportToExcel()} />}
      />

      {/* --- DATA GRID --- */}
      <FinancingRoundsDataGrid
        ref={gridRef}
        searchText={searchText}
      />
    </Box>
  );
}